<div class="boxWhite" *ngIf="viaje">
  <h4>CANCELAR VIAJE</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" alt="">
  </button>

  <div class="headInfo bgLightGray">
    <div class="servicio">
      <span>SERVICIO</span>
      <h4>{{ viaje.servicio }}</h4>
    </div>
    <div class="info">
      <div class="item">
        <span>ID VIAJE</span>
        <p>{{ viaje.viajeCodigo }}</p>
      </div>
      <div class="item">
        <span>INICIO</span>
        <p>{{ viaje.fechahoraInicio | date:'HH:mm' }}</p>
      </div>
      <div class="item">
        <span>SENTIDO</span>
        <p>{{ viaje.sentido || '--' }}</p>
      </div>
      <div class="item">
        <span>NOMBRE CB</span>
        <p>{{ viaje.conductor ? (viaje.conductor.nombres + ' ' + viaje.conductor.apellidoPaterno) : '--' }}</p>
      </div>
      <div class="item">
        <span>PATENTE</span>
        <p>{{ viaje.movil?.patente || '--' }}</p>
      </div>
    </div>
  </div>

  <div class="contModal mt-4">
    <div class="mb-3">
      <select class="form-select" [(ngModel)]="motivo">
        <option value="">SELECCIONE MOTIVO</option>
        <option *ngFor="let motivoItem of motivosCancelacion" [value]="motivoItem">{{ motivoItem }}</option>
      </select>
    </div>

    <div class="mb-3">
      <textarea class="form-control" rows="5" placeholder="ESCRIBA AQUÍ" [(ngModel)]="observaciones"></textarea>
    </div>
  </div>

  <div class="footModal mt-3">
    <button *ngIf="tienePermisoCancelarViaje()" class="btn btnRed w-100" (click)="cancelarViaje()" [disabled]="!motivo || enviando">
      <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      CANCELAR VIAJE
    </button>
  </div>
</div>
